import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-saree',
  templateUrl: './saree.component.html',
  styleUrls: ['./saree.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class SareeComponent implements OnInit {
  firstFormGroup: UntypedFormGroup;
  type: any;
  text: number;
  image: any
  sareeKey: any;
  entityId: any;
  price: any;
  childKey: any;
  primaryIndex: any;
  constructor(
    private dialogRef: MatDialogRef<SareeComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private dialog: MatDialog,
    private _formBuilder: UntypedFormBuilder
  ) {
    this.sareeKey = data.page;
    this.price = data.value;
    this.entityId = data.entityId
    this.childKey = data.childKey

    this.primaryIndex = data.primaryIndex

  }

  ngOnInit(): void {
    this.SareeCustomeValueForm();
    this.image = this.sareeDemo[0];

  }



  SareeCustomeValueForm() {
    this.firstFormGroup = this._formBuilder.group({
      "blouseLength": ['', [Validators.required]],
      "shoulder": ['', [Validators.required]],
      "sleeveLength": ['', [Validators.required]],
      'sleeveStyle': ['', [Validators.required]],
      "aroundArmhole": ['', [Validators.required]],
      "aroundArm": ['', [Validators.required]],
      "aroundBust": ['', [Validators.required]],
      "aroundAboveWaist": ['', [Validators.required]],
      "frontNeckDepth": ['', [Validators.required]],
      "frontNeckStyle": ['', [Validators.required]],
      "backNeckDepth": ['', [Validators.required]],
      "backNeckStyle": ['', [Validators.required]],
      "instruction": ['', ],
    })
  }


  close() {
    this.dialog.closeAll();
    this.dialogRef.close({
      event: 'close',
      data: this.entityId,
      key: this.sareeKey,
      additionalInfoGiven: 0,
      additional: null,
      value: this.price,
      childKey: this.childKey,
      index: this.primaryIndex,
    })
  }

  // summit(){

  // }



  yesChange(param) {

    this.type = param;

  }

  getImage(i) {
    this.text = i;
    this.image = this.sareeDemo[i]
  }




  sareeDemo: any = [
    "assets/saree/1.jpg",
    "assets/saree/2.jpg",
    "assets/saree/3.jpg",
    "assets/saree/5.jpg",
    "assets/saree/6.jpg",
    "assets/saree/7.jpg",
    "assets/saree/8.jpg",
    "assets/saree/9.jpg",
    "assets/saree/11.jpg",
  ]

}
